import { render, staticRenderFns } from "./GlobalMessage.vue?vue&type=template&id=74383c6e&"
import script from "./GlobalMessage.vue?vue&type=script&lang=js&"
export * from "./GlobalMessage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMessage.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports